import React from 'react';
import { flexRender, Row } from '@tanstack/react-table';
import { StyledCell, StyledCellContent, StyledRow } from '../../AllieDataGrid.styles';

export type DataGridRowProps = {
  row: any;
  renderSubComponent?: (props: { row: Row<any> }) => React.ReactElement;
  renderFootRow?: (row: Row<any>) => React.ReactElement;
  renderHeadRow?: (row: Row<any>) => React.ReactElement;
  headerStyle?: React.CSSProperties;
};
export const DataGridRow: React.FC<DataGridRowProps> = ({
  row,
  renderSubComponent,
  renderFootRow,
  renderHeadRow,
  headerStyle,
}) => {
  const isOdd = row.index % 2 !== 0;
  return (
    <>
      {renderHeadRow && (
        <StyledRow>
          <StyledCell
            data-isodd={isOdd}
            colSpan={row.getVisibleCells().length}
            style={{ paddingBottom: 0 }}
          >
            <div className="head-cell">{renderHeadRow(row)}</div>
          </StyledCell>
        </StyledRow>
      )}
      <StyledRow>
        {row.getVisibleCells().map((cell: any, index: number) => (
          <StyledCell
            key={`${cell.id}-${index}`}
            justify={cell.column.columnDef?.meta?.justify}
            data-isodd={isOdd}
            style={{
              width: cell.column.getSize(),
            }}
            className={`${renderFootRow ? 'has-foot' : ''} ${renderHeadRow ? 'has-head' : ''}`}
          >
            <StyledCellContent isOdd={isOdd} style={headerStyle}>
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </StyledCellContent>
          </StyledCell>
        ))}
      </StyledRow>
      {renderFootRow && (
        <StyledRow>
          <StyledCell
            data-isodd={isOdd}
            colSpan={row.getVisibleCells().length}
            style={{ paddingTop: 0 }}
          >
            <div className="foot-cell">{renderFootRow(row)}</div>
          </StyledCell>
        </StyledRow>
      )}
      {renderSubComponent && row.getIsExpanded() && (
        <StyledRow>
          <StyledCell colSpan={row.getVisibleCells().length}>
            {renderSubComponent && renderSubComponent({ row })}
          </StyledCell>
        </StyledRow>
      )}
    </>
  );
};
